import { Button, ButtonGroup, Chip, TableCell } from "@mui/material";
import RMFDataGrid from "../shared/data-grid/RMFDataGrid";
import { useDb } from "../../contexts/DatabaseContext";

import { Delete, Edit } from "@mui/icons-material";

export default function PopupsList({ popups, handleEdit }) {
  const { deleteStandardDoc } = useDb();

  const handleEditOpen = (popupId, popupData) => {
    handleEdit(popupId, popupData);
  };

  const handleDelete = async (popupId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this popup? This action cannot be undone.",
    );
    if (confirm) {
      await deleteStandardDoc("popups", popupId);
    }
  };

  const rows =
    popups &&
    popups.map((popup) => ({
      ...popup,
    }));

  const columns = [
    {
      field: "title",
      headerName: "Title",
      width: 350,
      renderCell: (params) => {
        return (
          <Button
            href={params.row.headerImage}
            target="_blank"
            rel="noopener noreferrer"
          >
            {params.row.title}
          </Button>
        );
      },
    },
    {
      field: "active",
      headerName: "Is Active",
      width: 200,
      renderCell: (params) => {
        if (
          params.row.expire &&
          params.row.expiry_date.toDate() <= new Date()
        ) {
          return <Chip color="error" label="Expired" />;
        } else
          return params.row.active ? (
            <Chip color="success" label="Active" />
          ) : (
            <Chip color="error" label="Inactive" />
          );
      },
    },
    {
      field: "id",
      headerName: "Action",
      width: 400,
      // @ts-ignore
      renderCell: (params) => {
        return (
          <TableCell>
            <ButtonGroup>
              <Button
                size="small"
                startIcon={<Edit />}
                color="primary"
                onClick={() => handleEditOpen(params.row.id, params.row)}
              >
                Edit
              </Button>
              <Button
                size="small"
                startIcon={<Delete />}
                color="error"
                onClick={() => handleDelete(params.row.id)}
              >
                Delete
              </Button>
            </ButtonGroup>
          </TableCell>
        );
      },
    },
  ];
  return <RMFDataGrid data={rows} columns={columns} />;
}
